const skillsData = [
    {
      headerIcon: "fa-solid fa-code",
      headerTitle: "Languages",
      headerSubtitle: "Programming Languages I know",
      skills: [
        {
          name: "Python",
          url: "https://www.python.org/",
          icon: "./assets/images/skillImages/icons_python.svg",
        },
        {
          name: "Java",
          url: "https://www.java.com/",
          icon: "./assets/images/skillImages/icons_java.svg",
        },
        {
          name: "C",
          url: "https://en.cppreference.com/",
          icon: "./assets/images/skillImages/icons_c.svg",
        },
        {
          name: "C++",
          url: "https://en.cppreference.com/",
          icon: "./assets/images/skillImages/icons_cpp.svg",
        },
        {
          name: "HTML",
          url: "https://www.w3.org/standards/webdesign/htmlcss.html",
          icon: "./assets/images/skillImages/icons_html.svg",
        },
        {
          name: "CSS",
          url: "https://www.w3.org/standards/webdesign/htmlcss.html",
          icon: "./assets/images/skillImages/icons_css.svg",
        },
        {
          name: "JavaScript",
          url: "https://www.javascript.com/",
          icon: "./assets/images/skillImages/icons_javascript1.svg",
        },
        {
          name: "SQL",
          url: "https://www.w3schools.com/sql/",
          icon: "./assets/images/skillImages/icons_sql.svg",
        },
      ],
    },
    {
      headerIcon: "fa-solid fa-wrench",
      headerTitle: "Tools",
      headerSubtitle: "Tools I work with",
      skills: [
        {
          name: "VS Code",
          url: "https://code.visualstudio.com/",
          icon: "./assets/images/skillImages/icons_vscode.svg",
        },
        {
          name: "Android Studio",
          url: "https://developer.android.com/studio",
          icon: "./assets/images/skillImages/icons_androidstudio.svg",
        },
        {
          name: "GitHub",
          url: "https://github.com/",
          icon: "./assets/images/skillImages/icons_github.svg",
        },
        {
          name: "Jupyter Notebooks",
          url: "https://jupyter.org/",
          icon: "./assets/images/skillImages/icons_jupyter.svg",
        },
        {
          name: "Power BI",
          url: "https://powerbi.microsoft.com/en-us/",
          icon: "./assets/images/skillImages/icons_microsoft-power-bi.svg",
        },
        {
          name: "MATLAB",
          url: "https://www.mathworks.com/products/matlab.html",
          icon: "./assets/images/skillImages/icons_matlab.svg",
        },
        {
          name: "Canva",
          url: "https://www.canva.com/;https://www.canva.com/",
          icon: "./assets/images/skillImages/icons_canva.svg",
        },
        {
          name: "Figma",
          url: "https://www.canva.com/;https://www.figma.com/",
          icon: "./assets/images/skillImages/icons_figma.svg",
        },
      ],
    },
    {
      headerIcon: "fa-solid fa-puzzle-piece",
      headerTitle: "Frameworks",
      headerSubtitle: "Frameworks I use",
      skills: [
        {
          name: "Android SDK",
          url: "https://developer.android.com/studio/sdk",
          icon: "./assets/images/skillImages/icons_android.svg",
        },
        {
          name: "Flask",
          url: "https://flask.palletsprojects.com/",
          icon: "./assets/images/skillImages/icons_flask.svg",
        },
        {
          name: "React",
          url: "https://react.dev/",
          icon: "./assets/images/skillImages/icons_react.svg",
        },
        {
          name: "Node.js",
          url: "https://nodejs.org/",
          icon: "./assets/images/skillImages/icons_node.svg",
        },
        {
          name: "Bootstrap",
          url: "https://getbootstrap.com/",
          icon: "./assets/images/skillImages/icons_bootstrap.svg",
        },
        {
          name: "MySQL Workbench",
          url: "https://www.mysql.com/products/workbench/",
          icon: "./assets/images/skillImages/icons_mysql-wordmark.svg",
        },
      ],
    },
    {
      headerIcon: "fa-solid fa-layer-group",
      headerTitle: "Libraries",
      headerSubtitle: "Libraries I am familiar with",
      skills: [
        {
          name: "Tkinter",
          url: "https://docs.python.org/3/library/tkinter.html",
        },
        { name: "NumPy", url: "https://numpy.org/" },
        { name: "Matplotlib", url: "https://matplotlib.org/" },
        { name: "Pandas", url: "https://pandas.pydata.org/" },
        { name: "PIL", url: "https://pillow.readthedocs.io/" },
        { name: "librosa", url: "https://librosa.org/" },
        { name: "OpenCV", url: "https://opencv.org/" },
        {
          name: "winsound",
          url: "https://docs.python.org/3/library/winsound.html",
        },
        { name: "pyttsx3", url: "https://pypi.org/project/pyttsx3/" },
      ],
    },
  ];

  export default skillsData;